import { ME_PATH, SIGNOUT_PATH } from 'dpl/shared/constants/urls';

import { getUserIdFromWindow } from './';

export const currentUserQueryDefinition = {
  url: ME_PATH,
  config: {
    enabled: Boolean(getUserIdFromWindow())
  }
};

export const currentUserLoginMutationDefinition = {
  url: '/api/users/sign_in.json',
  method: 'POST',
  updateStrategy: 'success'
};

export const currentUserLogoutMutationDefinition = {
  url: SIGNOUT_PATH,
  method: 'DELETE'
};

export const notificationCountsQueryDefinition = {
  url: '/api/notifications.json',
  defaultValue: {
    meta: {},
    data: {}
  },
  config: {
    enabled: getUserIdFromWindow()
  }
};

export function quizSectionMutationDefinition(submissionId, sectionUuid) {
  return {
    url: `/api/quiz_submissions/${submissionId}/quiz_sections/${sectionUuid}`,
    method: 'PUT',
    config: {
      throwOnError: true
      // added to cause any mutation errors to bubble up to where its called
    }
  };
}

export function quizSubmissionResourceDefinition(submissionId, sectionIdx) {
  return {
    url: `/api/quiz_submissions/${submissionId}`,
    params: {
      section_idx: sectionIdx
    },
    defaultValue: {
      sections: []
    },
    config: {
      staleTime: 0,
      cacheTime: 0
    }
  };
}

export function quizSubmissionMutationDefinition(submissionId) {
  return {
    url: `/api/quiz_submissions/${submissionId}`,
    method: 'PUT'
  };
}
